import Patnewcss from "../../public/css/patient/privacypolicy.css";
import React, { Component, useState } from "react";
import PatientFooter from "../patient/Patientfooter";
import Constant from "../../constants";
export default class PatientPastIllness extends Component {
   constructor(props) {
      super(props);
      this.state = {};
   }
   handleLanguage = (langValue) => {
      this.setState({ Language: langValue });
   };
   render() {
      return (
         <main id="main">
            <section id="privacy_policy">
               <div class="page_title">
                  <div class="container">
                     <div class="row">
                        <div class="col-md-12 no_padding">
                           <div class="heading">
                              <h1>Privacy Policy</h1>
                              <div class="breadcrumbs">
                                 <ul>
                                    <li><a href={Constant.imgurl}>Home</a></li>
                                    <span>
                                       <i class="fa fa-chevron-right"></i>
                                    </span>
                                    <li class="active">Privacy Policy</li>
                                 </ul>
                              </div>
                           </div>

                        </div>
                     </div>
                  </div>
               </div>
               <div class="container">
                  <div class="row">
                     <div class="col-md-12 no_padding">
                        <div class="privacy_box">
                        {/* <div class="coming_soon">
                              <h2>Coming Soon</h2>
                           </div> */}
                          <div class="privacy_content">

           <div class="privacy_list">
    <h2>This privacy notice discloses the privacy practices for <a href="http://www.medleymed.com"> http://www.medleymed.com. </a>This privacy
        notice applies solely to information collected by this website. It will notify
        you of the following:</h2>
    <ul>
        <li>What personally identifiable information is collected from you through the
            website, how it is used and with whom it may be shared.</li>
        <li>What choices are available to you regarding the use of your data.</li>
        <li>The security procedures in place to protect the misuse of your information.
        </li>
        <li>How you can correct any inaccuracies in the information.</li>
    </ul>
</div>
<div class="privacy_list">
    <h1>INFORMATION COLLECTION, USE, AND SHARING</h1>
    <ul>
        <li>We are the sole owners of the information collected on this site. We only
            have access to/collect information that you voluntarily give us via email or
            other direct contact from you. We will not sell or rent this information to
            anyone.</li>
        <li>We will use your information to respond to you, regarding the reason you
            contacted us. We will not share your information with any third party
            outside of our organization, other than as necessary to fulfill your
            request, e.g. to ship an order.</li>
        <li>Unless you ask us not to, we may contact you via email in the future to tell
            you about specials, new products or services, or changes to this privacy
            policy.</li>
    </ul>
</div>
<div class="privacy_list">
    <h1>YOUR ACCESS TO AND CONTROL OVER INFORMATION</h1>
    <h2>You may opt out of any future contacts from us at any time. You can do the
        following at any time by contacting us via the email address or phone number
        given on our website:</h2>
    <ul>
        <li>See what data we have about you, if any.</li>
        <li>Change/correct any data we have about you.</li>
        <li>Have us delete any data we have about you.</li>
        <li>Express any concern you have about our use of your data.</li>
    </ul>
</div>
<div class="privacy_list">
    <h1>SECURITY</h1>
    <h2>We take precautions to protect your information. When you submit sensitive
        information via the website, your information is protected both online and
        offline.</h2>
    <h2>Wherever we collect sensitive information (such as credit card data), that
        information is encrypted and transmitted to us in a secure way. You can verify
        this by looking for a lock icon in the address bar and looking for "https" at
        the beginning of the address of the Web page</h2>
    <h2>While we use encryption to protect sensitive information transmitted online, we
        also protect your information offline. Only employees who need the information
        to perform a specific job (for example, billing or customer service) are granted
        access to personally identifiable information. The computers/servers in which we
        store personally identifiable information are kept in a secure environment.</h2>
    <h2>If you feel that we are not abiding by this privacy policy, you should contact
        us immediately via email at <a href="#">info@medleymed.com</a></h2>
</div>
</div>
                        </div>
                     </div>
                  </div>
               </div>
            </section>
            {/* <PatientFooter /> */}
         </main>
      );
   }
}
